import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import PageHero from "@/components/site/PageHero";
import { Reveal } from "@/components/site/Reveal";
import { useSeo } from "@/hooks/useSeo";

const PHOTOS = [
  { label: "Premises", img: "/img/premises_home.webp" },
  { label: "Preparation", img: "/img/workshop.webp" },
  { label: "Local area", img: "/img/country.webp" },
];

export default function About() {
  useSeo({ title: "About Cirencester 4x4 | Independent 4x4 Specialist in Cirencester", description: "Cirencester 4x4 is a locally rooted, independent specialist in used 4x4s and SUVs, focused on a small number of carefully chosen vehicles.", path: "/about" });
  return (
    <main data-testid="about-page">
      <PageHero eyebrow="About" title="A specialist approach to buying 4x4s." />
      <section className="mx-auto grid max-w-[1440px] gap-12 px-5 py-20 sm:px-8 lg:grid-cols-12 lg:px-12 lg:py-28">
        <Reveal className="lg:col-span-5">
          <p className="font-serif text-3xl leading-snug text-forest">Cirencester 4x4 was created around a simple idea: buying a good used 4x4 should feel straightforward.</p>
        </Reveal>
        <Reveal className="prose-c4 text-base text-charcoal/85 lg:col-span-6 lg:col-start-7" delay={0.1}>
          <p>We focus on a relatively small number of carefully chosen vehicles rather than trying to stock everything.</p>
          <p>That allows us to understand the cars we sell, prepare them properly and give customers useful information before they make a decision.</p>
          <Link to="/the-cirencester-standard" className="btn btn-secondary mt-4" data-testid="about-standard-cta">The Cirencester Standard <ArrowRight className="arrow h-4 w-4" /></Link>
        </Reveal>
      </section>
      <section className="mx-auto max-w-[1440px] px-5 pb-28 sm:px-8 lg:px-12" data-testid="about-photos">
        <div className="grid gap-4 sm:grid-cols-3">
          {PHOTOS.map((p, i) => (
            <Reveal key={p.label} delay={i * 0.06} className={i % 2 ? "lg:mt-16" : ""}>
              <figure>
                <div className="img-zoom aspect-[3/4] overflow-hidden bg-stone">
                  <img src={p.img} alt={p.label} loading="lazy" className="h-full w-full object-cover" />
                </div>
                <figcaption className="eyebrow mt-3 text-charcoal/80">{p.label}</figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </section>
    </main>
  );
}
